export default {
  configure: 'कॉन्फ़िगर',
  chat: 'चैट',
  transferToAgent: 'किसी एजेंट को स्थानांतरित करें',
  clickToHelpPerson: 'इस व्यक्ति को मदद की जरूरत है',
  openConversation: ' उनकी मदद करने के लिए क्लिक करें',
  conversations: 'खुली बातचीत',
  noPendingConversations: 'बातचीत',
  lastMessage: 'बातचीत लंबित नहीं है',
  channel: 'अंतिम संदेश',
  yourConversations: 'चैनल',
  closedConversations: 'आपकी बातचीत',
  allConversations: 'बंद बातचीत',
  finishConversation: 'सभी बातचीत',
  closeChat: 'बातचीत खत्म करें',
  loadingMessages: 'बंद चैट',
  noMessagesFound: 'संदेश लोड करना',
  conversationAlreadyTaken: 'कोई संदेश नहीं है',
  toWrite: 'पहले ही ली गई बातचीत',
  toHelp: 'लिखने',
  attendConversation: 'मदद',
  quickResponses: 'बातचीत में भाग लें',
  writeMessage: 'त्वरित प्रतिक्रियाएं',
  conversationFinishedByAdvisor: 'संदेश लिखें',
  finishedConversation: 'सलाहकार द्वारा समाप्त बातचीत',
  conversationTakenByAdvisor: 'बातचीत समाप्त',
  updatedConversation: 'सलाहकार द्वारा ली गई बातचीत',
  configureChat: 'अद्यतन बातचीत',
  loadingConversations: 'कॉन्फ़िगर चैट',
  waitingForAdvisor: 'बातचीत लोड हो रही है',
  finished: 'सलाहकार के लिए इंतज़ार कर रहे',
  takenByMe: 'समाप्त',
  takenByAdvisor: 'मेरे द्वारा लिया गया',
  withAdvisor: '{सलाहकार द्वारा लिया गया}',
  registered: 'सलाहकार के साथ',
  canIHelpYouWithSomething: 'व्यक्ति ने अभी तक नहीं लिखा है',
  attachInWebSite: 'क्या मैं आपकी किसी चीज़ में मदद कर सकता हूं?',
  authenticationType: 'वेब साइट में संलग्न',
  noAuthentication: 'ऑथेंटिकेशन प्रकार',
  externalAuthentication: 'प्रमाणीकरण के बिना',
  form: 'बाहरी प्रमाणीकरण',
  city: 'प्रपत्र',
  appearance: 'शहर',
  light: 'उपस्थिति',
  dark: 'प्रकाश',
  mainColor: 'अंधेरा',
  pickAMainColor: 'मुख्य रंग',
  reestablishColor: 'एक मुख्य रंग चुनें',
  backgroundColor: 'फिर से स्थापित रंग',
  pickABackgroundColor: 'बैकग्राउंड कलर',
  customLogo: 'बैकग्राउंड कलर चुनें',
  customTitle: 'कस्टम लोगो',
  customBubbleMessage: 'कस्टम शीर्षक',
  showEmojis: 'कस्टम बबल संदेश',
  customQuestions: 'इमोजी दिखाएं',
  insertChatQuestions: 'कस्टम प्रश्न',
  permanentMessages: 'चैट में आप जो प्रश्न दिखाना चाहते हैं',
  insertFirstChatMessages: ' उन्हें दर्ज करें',
  reasonsOfFinishedConversation: 'स्थायी संदेश',
  possibleReasonsAdvisorEndConversation: 'वे संदेश दर्ज करें जिन्हें आप पहले चैट संदेश के रूप में प्रदर्शित करना चाहते हैं',
  insertQuickResponsesForAdvisors: 'बातचीत समाप्त होने के कारण',
  inactivityMessage: 'मुख्य कारणों से दर्ज करें कि सलाहकार बातचीत समाप्त क्यों कर सकता है',
  enableInactivityMessage: 'सलाहकारों के पास उपलब्ध त्वरित प्रतिक्रियाएं दर्ज करें',
  insertInactivityMessage: 'आयता संदेश',
  timeForTriggeringInactivityMessage: 'निष्क्रियता संदेश सक्षम करें',
  attentionSchedule: 'निष्क्रियता संदेश दर्ज करें',
  outOfServiceMessage: 'निष्क्रियता संदेश को ट्रिगर करने के लिए सेकंड में समय',
  customFormMessage: 'ध्यान कार्यक्रम',
  nonWorkingDay: 'सेवा से बाहर संदेश',
  allDay: 'कस्टम फॉर्म संदेश',
  noOpening: 'नॉनवर्किंग डे',
  noClosing: 'पूरे दिन',
  advisors: 'कोई उद्घाटन नहीं',
  assignConversationsAutomaticallyToConnectedAdvisors: 'बंद करने के बिना',
  pickAdvisors: 'सलाहकार',
  monday: 'कनेक्टेड सलाहकारों को बातचीत स्वचालित रूप से असाइन करें',
  tuesday: 'सलाहकार चुनें',
  wednesday: 'सोमवार',
  thursday: 'मंगलवार',
  friday: 'बुधवार',
  saturday: 'गुरुवार',
  sunday: 'शुक्रवार',
  configurationSavedSuccessfully: 'शनिवार',
  insertChatInYourWebSite: 'रविवार',
  instructionsForInsertingChat: 'सेटिंग्स सफलतापूर्वक सहेजे गए',
  copiedScript: 'योर वेबसाइट में चैट डालें',
  errorCopyingScript: 'अपनी वेबसाइट में चैट जोड़ने के लिए',
  noMessage: ' आपको अपनी साइट के पाद लेख में अगली स्क्रिप्ट जोड़नी होगी',
  toTransfer: 'कॉपी की गई स्क्रिप्ट',
  agentSuccessfullyTransferred: 'स्क्रिप्ट की नकल करने में त्रुटि',
  youAreDeclaringNoWorkingDay: 'संदेश के बिना',
  opening: 'स्थानांतरण',
  closing: 'एजेंट सफलतापूर्वक स्थानांतरित',
  establishAgentsForSelfAllocationOfConversations: 'आप इस दिन को गैर-कार्य दिवस घोषित कर रहे हैं',
  assignConversations: 'खोलना',
  ready: 'बंद',
  advisorUpdated: 'बातचीत के आत्म आवंटन के लिए एजेंटों की स्थापना',
  errorPrecessingRequest: 'बातचीत असाइन करें',
  periodStatistics: 'तैयार',
  noStatsFoundForThisDateRange: 'अद्यतन सलाहकार',
  forEachDayHowMuchWasTheAverageTimePerConversation: 'अनुरोध पर कार्रवाई करते समय एक त्रुटि हुई',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: 'अवधि के आंकड़े',
  statsPerDay: 'इस तिथि सीमा के लिए कोई आंकड़े नहीं मिले',
  noStatsFoundForThisDay: 'प्रत्येक दिन के लिए',
  usersCreated: ' कितना बातचीत प्रति औसत समय था?',
  attendedConversations: 'प्रत्येक सलाहकार के लिए',
  noAttendedConversations: ' कितना बातचीत प्रति औसत समय था?',
  attendedAndUnansweredConversations: 'संलग्न और अनअटेंडेड वार्तालाप',
  attended: 'आंकड़े प्रति दिन',
  averageTimeBeforeTheAdvisorTookControl: 'इस दिन के लिए कोई आंकड़े नहीं मिले',
  averageTimeSinceTheAdvisorTookControl: 'उपयोगकर्ताओं को बनाया',
  howManyWereAttended: 'बातचीत में भाग लिया',
  conversationsNumber: 'अनुत्तरित बातचीत',
  howManyConversationsDidEachAdvisorAttended: 'भाग लिया',
  numberConversationsAttended: 'सलाहकार के नियंत्रण से पहले औसत समय',
  howManyUsersWereCreated: 'सलाहकार के नियंत्रण के बाद से औसत समय',
  users: 'कितने भाग लिया?',
  howLongWasTheAverageTimePerConversation: 'बातचीत की संख्या',
  minutes: 'प्रत्येक सलाहकार ने कितनी बातचीत में भाग लिया?',
  whatWereTheTopicsOfTheConversations: 'बातचीत की संख्या में भाग लिया',
  numberOfRepetitions: 'कितने उपयोगकर्ता बनाए गए थे?',
  howManyConversationsWereAttendedForEachHour: 'उपयोगकर्ताओं',
  howManyConversationsDidEachAdvisorHavePerHour: 'कब तक बातचीत के प्रति औसत समय था?',
  howManyUsersWereCreatedPerHour: 'मिनट',
  advisor: 'बातचीत के विषय क्या थे',
  tellUsWhoYouAre: 'पुनरावृत्ति की संख्या',
  selectTheInformationYouWantToAskPeople: 'प्रत्येक घंटे के लिए कितनी बातचीत में भाग लिया?',
  startConversation: 'प्रत्येक सलाहकार के पास प्रति घंटे कितनी बातचीत हुई?',
  emptyMessage: 'प्रति घंटे कितने उपयोगकर्ता बनाए गए थे?',
  blockMessageComposer: 'सलाहकार',
  timeZone: 'हमें बताएं कि आप कौन हैं',
  addSchedule: ' आप लोगों से पूछने के लिए चाहते हैं जानकारी का चयन करें',
  checkTheServiceHours: 'बातचीत शुरू करें',
  newKeybeConversation: 'खाली संदेश',
  details: 'ब्लॉक संदेश संगीतकार',
  enterName: 'टाइम जोन',
  enterEmail: 'शेड्यूल जोड़ें',
  enterPhone: 'सेवा के घंटे की जांच करें',
  enterCountry: 'नई कीबे वार्तालाप',
  country: 'विवरण',
  enter: 'नाम दर्ज करें',
  enterValue: 'ईमेल दर्ज करें',
  selectPerson: 'फोन दर्ज करें',
  anonymousPerson: 'देश में प्रवेश करें',
  personDetails: 'देश',
  newApplication: 'दर्ज',
  channels: 'चैनल',
  authentication: 'प्रमाणीकरण',
  finalization: 'समापन',
  customizeYourConversation: 'अपनी बातचीत को अनुकूलित करें',
  schedules: 'अनुसूची',
  assignment: 'असाइनमेंट',
  correctlyEmailConnection: 'आपका ईमेल सही तरीके से कनेक्ट किया गया है',
  correctlyEmailDisconnection: 'आपका ईमेल सफलतापूर्वक काट दिया गया है',
  administratorsOnly: 'प्रशासक ही',
  setTheEndTimeForConversations: 'बातचीत के लिए अंतिम समय निर्धारित करें',
  automaticallyEndUnansweredConversations: 'स्वचालित रूप से समाप्त होने वाली बातचीत का जवाब देना बंद कर दिया है',
  definesTheTimeUserStopsResponding: 'उपयोगकर्ता द्वारा प्रतिसाद देना बंद करने के बाद वार्तालाप समाप्त करने का समय निर्धारित करता है',
  finishAfter: 'के बाद समाप्त करें',
  enterTheReasonForAutomaticCompletion: 'स्वत: पूर्ण होने का कारण दर्ज करें',
  position: 'पद',
  defaultLanguage: 'डिफ़ॉल्ट भाषा',
  tagsAsAMethodOfAutoAssignment: 'ऑटो-असाइनमेंट की एक विधि के रूप में टैग',
  enterTags: 'टैग दर्ज करें',
  updateTags: 'अद्यतन टैग',
  communicationChannels: 'संचार कढ़ी',
  youMustPreviouslyGrantKeybeGooglePermission: 'अपने Google खाते तक पहुंचने के लिए आपको पहले कीबे की अनुमति देनी होगी',
  connectWithGoogle: 'Google से कनेक्ट करें',
  youHaveCurrentlyAuthorizedKeybe: 'आपने वर्तमान में अपने खाते तक पहुंचने के लिए कीबे को अधिकृत किया है',
  andYouHaveCorrectlyConfiguredGmail: 'और आपने जीमेल को सही ढंग से कॉन्फ़िगर किया है',
  disconnectFromGmail: 'जीमेल से डिस्कनेक्ट करें',
  connectToGmail: 'जीमेल से कनेक्ट करें',
  notificationPermissions: 'आपने सूचनाएं दिखाने की अनुमति को अस्वीकार कर दिया। वेब पता बार में साइट की जानकारी की जाँच करें और जब आप एक संदेश प्राप्त करते हैं तो अलर्ट प्राप्त करने के लिए सूचनाओं को जारी रखने की अनुमति दें',
  dontShowMessage: 'इस संदेश को फिर से न दिखाएं'
}
